<template>
	<div class="cf" :class="['cf-' + contentType]" v-if="searchFields.length">
        <BaseCatalogFilterItem v-for="(filter, index) in searchFields" :key="filter.id" :item="filter" v-slot="{fields, onFilter, selectedFilters, active, onToggle}">
			<CatalogSidebarCategories v-if="contentType == 'category' && filter.code == 'categories'" :category="category" />
			
        	<div v-if="index == 1" class="cf-title cf-filters-title"><span><BaseCmsLabel code="filters" /></span></div>

			<div class="cf-item" :class="['cf-item-' + filter.code, filter.layout ? 'cf-layout-' + filter.layout : '', {'active': active}]" v-if="filter.code !== 'categories' || filter.code === 'categories' && contentType !== 'category'">
				<div v-if="filter.code != 'categories'" class="cf-title cf-title" @click="onToggle">
                    {{filter.label}}
					<div class="cf-filter-counter" v-show="selectedFilters?.length">{{selectedFilters?.length}}</div>
                    <span class="plus"></span>
                </div>
				<div v-else>
					<div class="cf-title cf-filters-title cf-filters-title-manufacturer"><span><BaseCmsLabel code="m_categories" /></span></div>
				</div>
				<div class="cf-item-wrapper">
					<div v-if="filter.layout == 'sf'" class="cf-row cf-row-price">
						<BaseCatalogFilterFieldSlider :item="filter" />
					</div>	
                    <div v-else class="cf-row" :class="[field.level && 'cf-row-level-f' + field.level, {'cf-row-not-available': field.total_available < 1 && !field.selected}, {'cf-row-level-parent': field.level && !field.total}]" v-for="field in fields" :key="field.id">
                        <input v-if="filter.code != 'categories' || field.level && field.level > 1 && field.total" type="checkbox" :disabled="field.total_available <= 0 && !field.selected  ? true : false" :name="filter.filter_url" :id="field.unique_code" :value="field.filter_url" :checked="field.selected" @click="onFilter" />                    
						<label :for="field.unique_code">{{field.title}}</label>
                    </div>			
				</div>
			</div>
		</BaseCatalogFilterItem>

		<BaseCatalogActiveFilters v-slot="{items, onRemove}">
			<div :class="['cf-btns', items?.length && 'active']">
				<div class="btn btn-m-filter btn-m-cf-active-clear" @click="onRemove(), $emit('closeFilters');"><BaseCmsLabel code="clear_all_filtering" /></div>
				<div class="btn-m-filter btn-m-cf-confirm" @click="$emit('closeFilters');"><BaseCmsLabel code="confirm_filters" /> <span>{{totalProducts}}</span> <BaseCmsLabel code="products2" /></div>
			</div>
		</BaseCatalogActiveFilters>
	</div>
</template>

<script setup>
	const props = defineProps(['totalProducts', 'searchFields', 'contentType', 'category']);
	const emit = defineEmits(['closeFilters']);
</script>